module.exports = __webpack_public_path__ + "img/image_testi_borrower_2.bfb89e46.png";